<script lang="ts" setup>
    import type { PropType, } from "vue";
    import { ref } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    import type { Cta } from "@/helpers/builder-init/index";

    interface AccordionItem {
        title: string;
        content: string;
    }

    interface AccordionDetail {
        items: AccordionItem[];
    }
    let props = defineProps({
        headline: {
            type: String,
            required: false
        },
        bgColor: {
            type: String,
            required: false,
            default: 'rothcoCream'
        },

        cta: {
            type: Object as PropType<Cta>,
            required: false
        },
        accordionDetails: {
            type: Array as PropType<AccordionItem[]>,
            required: true
        }
        
    })

    let accordionDetailElements = ref([]);

    let accordionDetailOpened = ref(
        props.accordionDetails.map(() => false)
    );

    let toggleAccordionDetail = (index: number) => {
        accordionDetailOpened.value[index] = !accordionDetailOpened.value[index];
    };
</script>
<template>
    <div :class="`accordion-wrapper bg-${bgColor}`">
      <div class="accordion-header">
          <h2 class="accordion-header__title headline-xl">{{ headline }}</h2>
          <RothcoCta v-if="cta" v-bind="getCtaLink(props.cta)">
            {{ cta.label }}
          </RothcoCta>
        </div>
        <div :class="`accordion-container bg-${bgColor}`">
          <details @click="toggleAccordionDetail(index)" ref="accordionDetailElements" class="accordion" v-for="(accordionDetail, index) of accordionDetails" :key="`detail-${index}`">
            <summary class="accordion__title" role="button">
              <h3 class="accordion__title-text paragraph-feature" role="heading" aria-level="3">{{ accordionDetail.title }}</h3>
            </summary>
            <div class="accordion__content" :aria-hidden="accordionDetailOpened[index] ? 'false' : 'true'">
              <div v-html="accordionDetail.content"></div>
            </div>
          </details>
          
          <div class="accordion__footer">
            <slot name="footer-content"></slot>
          </div>
        </div>
    </div>
</template>